module.exports = __webpack_public_path__ + "media/mobile-header-ar.edde184d.mp4";